import React, { FC } from 'react';

import { HttpStatus } from 'types/common';
import { ErrorPageProps } from 'types/pages';
import { RouteError } from 'types/routes';

import ErrorPage from '../Error';

const error = new Error('Page not found.') as RouteError;

error.status = HttpStatus.NOT_FOUND;

const NotFoundPage: FC<ErrorPageProps> = ({ customError = error, ...props }) => (
  <ErrorPage customError={customError} {...props} />
);

export default NotFoundPage;
